import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import parrot from '../../../assets/images/parrot_4.png';
import moment from 'moment';
import useAnalyticsEventTracker from '../../../hooks/use-analytics';
import SocialMediaButtons from '../../UI/SocialShare';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight, faStar } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import useFetch from '../../../hooks/use-fetch';

const ParrotIntro = ({
  slides,
  setShowIntro,
  lastLocation,
  lastLessonTime,
  showTutorial,
  tutorialCancelled,
  townData
}) => {
  const activeSlide = 0;
  const [activeClass, setActiveClass] = useState('');
  const totalSlides = slides.length;
  const gaEventTracker = useAnalyticsEventTracker('Map');
  const { t: translate } = useTranslation();
  let ParrotIntroTitle = translate('welcome-back');
  const [showHarderOptions, setShowHarderOptions] = useState(false);
  const { apiUrl} = window['appConfig'];
  const history = useHistory();
  const {initFunc: sendEndpointProgress} = useFetch()

  if (lastLocation === '') {
    ParrotIntroTitle = translate('welcome-pollywood')
  }

  if (lastLocation === 'Tutorial') {
    ParrotIntroTitle = translate('pollywood-tutorial-complete')
  }

  const finishIntro = () => {
    setShowIntro(false);

    if (lastLocation === '') {
      gaEventTracker('First visit parrot', '');
    }
  };

  const handleOptionClick = async (level, sceneInfo) => {
    let progressUrl = `${apiUrl}/user/event/starting/${level}/${sceneInfo.sceneId}`;
    let routeUrl = `/conversation/${sceneInfo.location}/${sceneInfo.sceneId}/1`;

    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    await sendEndpointProgress({url: progressUrl, options: fetchOptions});
    history.push(routeUrl);
  }

  const createStartPoints = () => {
    if( townData ) {
      let list = [];
      if( townData.startPoints['easy'] || townData.startPoints['medium'] || townData.startPoints['hard'] ) {
        list.push(<p key="options-title" className={`harder-options-control ${showHarderOptions ? "harder-options-control--active" : ""}`} onClick={() => {setShowHarderOptions(! showHarderOptions)}}>{translate('harder-options-title')} {<FontAwesomeIcon icon={faChevronDown} />}</p>)
        let harderOptions = <div key="harder-options" className={`harder-options ${showHarderOptions ? 'harder-options--active' : ''}`}>
          {townData.startPoints['easy'] && 
            <button 
              className='level--selector' key="easy" 
              onClick={() => {handleOptionClick('easy',townData.startPoints.easy)}}
            >
              <span className='difficulty-rating'>
                <FontAwesomeIcon icon={faStar} />
              </span>
              <span className='level--selector__text'>{translate('easy')}</span>
              <span className='button'><FontAwesomeIcon icon={faChevronRight} size="1x" /></span>
            </button>
          }

        {townData.startPoints['medium'] && 
          <button 
            className='level--selector' key="medium" 
            onClick={() => {handleOptionClick('medium',townData.startPoints.medium)}}
          >
            <span className='difficulty-rating'>
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
            </span>
            <span className='level--selector__text'>{translate('medium')}</span>
            <span className='button'><FontAwesomeIcon icon={faChevronRight} size="1x" /></span>
          </button>
        }

        {townData.startPoints['hard'] &&
          <button 
            className='level--selector' key="hard" 
            onClick={() => {handleOptionClick('hard',townData.startPoints.hard)}}
          >
            <span className='difficulty-rating'>
              <span className='difficulty-rating__group'><FontAwesomeIcon icon={faStar} /></span>
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
            </span>
            <span className='level--selector__text'>{translate('hard')}</span>
            <span className='button'><FontAwesomeIcon icon={faChevronRight} size="1x" /></span>
          </button>
        }
        </div>

        list.push(harderOptions);
      }

      return list;
    }
  }

  let content = (
    <div className="speech-container">
      <div className="speech-box">
        {slides.map((slide, index) => {
          let Tag = slide.tag ? slide.tag : 'p'; //defaults to p tag
          let slide_style =
            index === activeSlide
              ? { display: 'block' }
              : { display: 'none' };

          return (
            <Fragment key={index}>
              <h2>
                {ParrotIntroTitle}
              </h2>
              <div className='slide-content' style={slide_style}>
                {slide.content.map((content, index) => {
                  return (<Tag key={index}>{content}</Tag>)
                })}
              </div>
            </Fragment>
          );
        })}
        {<SocialMediaButtons code={'lgl'} />}
        {activeSlide < totalSlides && (
          <span className="button button--success" onClick={finishIntro}>
            {translate('explore-the-map')}
          </span>
        )}
        {createStartPoints()}
        {/* {activeSlide >= totalSlides && <span className='next-slide' onClick={finishIntro}>Done</span>} */}
      </div>
      <img
        src={parrot}
        className="parrot"
        alt="golingo Parrot"
        title="golingo Parrot"
      />
    </div>)

  if (!lastLocation && !tutorialCancelled) {
    content = ''
  }

  useEffect(() => {
    if (totalSlides > 0) {
      let halfAnHourAgo = moment().subtract(30, 'minutes');
      let lastLessonCompletionTime =
        moment(lastLessonTime).isBefore(halfAnHourAgo);

      if (showTutorial) {
        setTimeout(function () {
          gaEventTracker('Tutorial Started', '');
          finishIntro();
        }, 50);
      } else if (lastLocation === 'Tutorial') {
        setTimeout(function () {
          gaEventTracker('Tutorial Compeleted!', '');
          setActiveClass('active');
        }, 50);
      } else if (!lastLessonCompletionTime && lastLocation) {
        setTimeout(function () {
          finishIntro();
        }, 650);
      } else {
        setTimeout(function () {
          gaEventTracker('Parrot Intro Shown', '');
          setActiveClass('active');
        }, 50);
      }
    }
  }, [totalSlides]);

  return (
    <div className={`parrot-intro ${activeClass}`}>
      {totalSlides === 0 ? (
        <div className="parrot-intro__loader"></div>
      ) : (
        content
      )}
    </div>
  );
};

export default ParrotIntro;
